module.exports = __webpack_public_path__ + "img/Shrug.e05c10dc.png";